'use client'

import { defineStyleConfig, extendTheme, withDefaultColorScheme } from '@chakra-ui/react'
import merge from 'lodash/merge'
import appConfig from '#/src/appConfig'
import { baseTheme } from './theme.base'

const Checkbox = defineStyleConfig({
  defaultProps: {
    colorScheme: 'none'
  },
  baseStyle: {
    control: {
      bg: 'background.default',
      _checked: {
        bg: 'primary'
      },
      _focus: {
        shadow: 'none'
      }
    }
  }
})

const Popover = defineStyleConfig({
  variants: {
    responsive: {
      popper: {
        maxWidth: {
          base: 'unset',
          md: '500px'
        }
      },
      // @ts-expect-error -- TODO Chakra marks it as incompatible. Check if its working
      content: {
        width: {
          base: '100vw',
          md: '500px'
        }
      }
    }
  }
})

const Switch = defineStyleConfig({
  defaultProps: {
    colorScheme: 'gray'
  }
})

const Link = defineStyleConfig({
  baseStyle: {
    cursor: 'pointer'
  }
})

const Heading = defineStyleConfig({
  baseStyle: {
    fontFamily: 'heading'
  }
})

const Button = defineStyleConfig({
  baseStyle: {
    borderRadius: 'md',
    backgroundColor: 'primary',
    color: 'text.light',
    fontWeight: 'medium',
    minW: 140,
    outlineOffset: 0,
    transition: 'all 0.35s cubic-bezier(.08,.52,.52,1)'
  },
  sizes: {
    md: {
      minW: 140
    }
  },
  variants: {
    plain: {
      h: 'auto',
      w: 'auto',
      minW: 'auto',
      fontSize: 'inherit',
      color: 'inherit',
      border: 'none',
      boxShadow: 'none',
      outline: 'none',
      bg: 'transparent',
      p: 0
    }
  }
})

const CustomFooter = defineStyleConfig({
  baseStyle: (props) => {
    const footerStyles = props.theme?.components?.CustomFooter || {}
    return {
      bg: 'background.surface',
      p: {
        base: 4,
        md: 10
      },
      ...footerStyles
    }
  }
})

export const defaultTheme = extendTheme(
  withDefaultColorScheme({
    colorScheme: 'customColorScheme'
  }),
  baseTheme,
  {
    components: {
      Checkbox,
      Popover,
      Switch,
      Link,
      Button,
      Heading,
      CustomFooter
    }
  }
)

export const customTheme = merge(defaultTheme, appConfig.theme)

/** Have to use function to get customTheme when updating appConfig dynamically */
export const getCustomTheme = () => merge(defaultTheme, appConfig.theme)
